import React, { useState } from "react";
import Button from "components/shared/Button";

const FieldEditor = ({ field, onSave, onCancel, fullWidth = false }) => {
	const [fieldType, setFieldType] = useState(field.type);
	const [label, setLabel] = useState(field.label || "");
	const [explainer, setExplainer] = useState(field.explainer || "");
	const [options, setOptions] = useState(field.options?.map((opt) => opt.value) || ["Option 1", "Option 2"]);
	const [min, setMin] = useState(field.min || 1);
	const [max, setMax] = useState(field.max || 5);
	const [separatorText, setSeparatorText] = useState(field.separatorText || "");

	const handleOptionChange = (index, value) => {
		const newOptions = [...options];
		newOptions[index] = value;
		setOptions(newOptions);
	};

	const handleDeleteOption = (index) => {
		const newOptions = options.filter((_, i) => i !== index);
		setOptions(newOptions);
	};

	const handleAddOption = () => {
		setOptions([...options, ""]);
	};

	const handleSave = () => {
		const updatedField = {
			type: fieldType,
			label,
			explainer,
			options: options.map((opt) => ({ value: opt.trim() })),
			min,
			max,
			separatorText,
		};
		onSave(updatedField);
	};

	return (
		<div
			className={`box small-shadow add-field-box ${
				fullWidth ? "field-editor--full-width" : "field-editor--inline"
			}`}
		>
			<div className="form-builder__add-field">
				<label className="field-input__label">Type</label>
				<div className="field-input field-undefined short">
					<select value={fieldType} onChange={(e) => setFieldType(e.target.value)}>
						<option value="short">Short Text</option>
						<option value="long">Long Text</option>
						<option value="rating">Rating (5 stars)</option>
						<option value="scale">Scale</option>
						<option value="radio">Single Choice</option>
						<option value="multiple">Multiple Choice</option>
						<option value="dropdown">Dropdown</option>
						<option value="email">Email</option>
						<option value="separator">Separator</option>
					</select>
				</div>
				{fieldType !== "separator" && (
					<>
						<label className="field-input__label">Field Title</label>
						<p className="field-input__explainer">
							This will be the title of the field, the actual question that you want an answer to.
						</p>
						<div className="field-input field-text short">
							<input type="text" value={label} onChange={(e) => setLabel(e.target.value)} />
						</div>
						<label className="field-input__label">Description</label>
						<p className="field-input__explainer">
							Optional. You can add more information or describe your question.
						</p>
						<div className="field-input field-text short">
							<input type="text" value={explainer} onChange={(e) => setExplainer(e.target.value)} />
						</div>
					</>
				)}
				{fieldType === "scale" && (
					<>
						<label className="field-input__label">Minimum Value</label>
						<div className="field-input field-text short">
							<input type="number" value={min} onChange={(e) => setMin(Number(e.target.value))} />
						</div>
						<label className="field-input__label">Maximum Value</label>
						<div className="field-input field-text short">
							<input type="number" value={max} onChange={(e) => setMax(Number(e.target.value))} />
						</div>
					</>
				)}
				{fieldType === "separator" && (
					<>
						<label className="field-input__label">Separator Text</label>
						<div className="field-input__explainer">
							Optional. Leave it blank if you just want a horizontal line
						</div>
						<div className="field-input field-text short">
							<input
								type="text"
								value={separatorText}
								onChange={(e) => setSeparatorText(e.target.value)}
							/>
						</div>
					</>
				)}
				{(fieldType === "dropdown" || fieldType === "radio" || fieldType === "multiple") && (
					<>
						<label className="field-input__label">Options</label>
						{options.map((option, index) => (
							<div key={index} className="field-input choice-controller">
								<input
									type="text"
									value={option}
									onChange={(e) => handleOptionChange(index, e.target.value)}
								/>
								<Button
									onClick={() => handleDeleteOption(index)}
									size="small"
									type="secondary"
									className="delete-option"
								/>
							</div>
						))}
						<Button
							text="+ Add Option"
							onClick={handleAddOption}
							type="text"
							size="small"
							className="add-option"
						/>
					</>
				)}
				<br />
				<div className="add-field">
					<Button
						text="Cancel"
						onClick={onCancel}
						type="secondary"
						size="large"
						className={"cancel-button"}
					/>
					<Button
						text="Add to form"
						onClick={handleSave}
						type="primary"
						size="large"
						disabled={!label && fieldType !== "separator"}
						className={!!label || fieldType === "separator" ? "disabled" : ""}
					/>
				</div>
			</div>
		</div>
	);
};

export default FieldEditor;
